var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-fingers",style:(_vm.styles.root)},_vm._l((_vm.points),function(point){return _c('finger',{key:point.id,attrs:{"rotation":point.rotation,"point":point}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }